export enum PERMISSIONS {
  // Create Permissions
  CREATE_EVENT = 'create.event',
  CREATE_MESSAGE = 'create.message',
  CREATE_APPOINTMENTS = 'create.appointments',
  CREATE_GROUP = 'create.group',
  CREATE_NEWS = 'create.news',
  CREATE_TASK = 'create.task',
  CREATE_SUBTASK = 'create.subtask',
  CREATE_DOCUMENT = 'create.document',
  CREATE_CHAT = 'create.chat',
  CREATE_CONTACT_ADMIN = 'create.contact_admin',
  CREATE_EMAIL = 'create.email',
  CREATE_THEME = 'create.theme',
  CREATE_IMPORT_CALENDAR = 'create.import_calendar',
  CREATE_UPLOAD_CALENDAR = 'create.upload_calendar',
  CREATE_COURSE = 'create.course',
  CREATE_INSTRUCTOR = 'create.instructor',
  CREATE_ROOM = 'create.room',
  CREATE_SURVEY = 'create.survey',
  CREATE_FAQ = 'create.faq',
  CREATE_CATEGORY = 'create.category',
  CREATE_BANNER = 'create.banner',
  CREATE_WORDING = 'create.wording',
  CREATE_ALL_LIST = 'create.all_list',
  CREATE_TAGS = 'create.tags',
  CREATE_CLUB_DATE = 'create.club_date', // Added new permission
  CREATE_MEMBERS_LIST = 'create.member_list', // Added new permission

  // Participate Permissions
  PARTICIPATE_EVENT = 'participate.event',
  PARTICIPATE_MESSAGE = 'participate.message',
  PARTICIPATE_APPOINTMENTS = 'participate.appointments',
  PARTICIPATE_GROUP = 'participate.group',
  PARTICIPATE_NEWS = 'participate.news',
  PARTICIPATE_TASK = 'participate.task',
  PARTICIPATE_SUBTASK = 'participate.subtask',
  PARTICIPATE_DOCUMENT = 'participate.document',
  PARTICIPATE_CHAT = 'participate.chat',
  PARTICIPATE_PERSONAL_MESSAGE = 'participate.personal_message',
  PARTICIPATE_CLUB_MESSAGE = 'participate.club_message',
  PARTICIPATE_GROUP_MESSAGE = 'participate.group_message',
  PARTICIPATE_ORGANIZER_MYDOCUMENT = 'participate.organizer_myDocument',
  PARTICIPATE_ORGANIZER_CLUBDOCUMENT = 'participate.organizer_clubDocument',
  PARTICIPATE_ORGANIZER_CURRENTSTATUS = 'participate.organizer_currentStatus',
  PARTICIPATE_ORGANIZER_ARCHIVEDDOCUMENT = 'participate.organizer_archivedDocument',
  PARTICIPATE_COURSE = 'participate.course',
  PARTICIPATE_INSTRUCTOR = 'participate.instructor',
  PARTICIPATE_ROOM = 'participate.room',
  PARTICIPATE_SURVEY = 'participate.survey',
  PARTICIPATE_FAQ = 'participate.faq',
  PARTICIPATE_CATEGORY = 'participate.category',
  PARTICIPATE_CRM_SURVEY = 'participate.crm_survey',
  PARTICIPATE_CRM_NEWS = 'participate.crm_news',
  PARTICIPATE_BANNER = 'participate.banner',
  PARTICIPATE_ALL_LIST = 'participate.all_list',
  PARTICIPATE_TAGS = 'participate.tags',
  PARTICIPATE_CLUB_DATE = 'participate.club_date', // Added new permission
  PARTICIPATE_BANNER_MOBILE = 'participate.banner_mobile', // Added new permission
  PARTICIPATE_EMAIL_MOBILE = 'participate.email_mobile', // Added new permission
  PARTICIPATE_MEMBERS_LIST = 'participate.member_list', // Added new permission

  // Authorization Permissions
  AUTHORIZATION_EVENT = 'authorization.event',
  AUTHORIZATION_MESSAGE = 'authorization.message',
  AUTHORIZATION_APPOINTMENTS = 'authorization.appointments',
  AUTHORIZATION_GROUP = 'authorization.group',
  AUTHORIZATION_NEWS = 'authorization.news',
  AUTHORIZATION_TASK = 'authorization.task',
  AUTHORIZATION_SUBTASK = 'authorization.subtask',
  AUTHORIZATION_DOCUMENT = 'authorization.document',
  AUTHORIZATION_CHAT = 'authorization.chat',
  AUTHORIZATION_COURSE = 'authorization.course',
  AUTHORIZATION_INSTRUCTOR = 'authorization.instructor',
  AUTHORIZATION_ROOM = 'authorization.room',
  AUTHORIZATION_SURVEY = 'authorization.survey',
  AUTHORIZATION_FAQ = 'authorization.faq',
  AUTHORIZATION_CATEGORY = 'authorization.category',
  AUTHORIZATION_BANNER = 'authorization.banner',
  AUTHORIZATION_ALL_LIST = 'authorization.all_list',
  AUTHORIZATION_TAGS = 'authorization.tags',
  AUTHORIZATION_CLUB_DATE = 'authorization.club_date', // Added new permission
  AUTHORIZATION_MEMBERS_LIST = 'authorization.member_list', // Added new permission

  // Other or Special Permission
  VCLOUD_COURSE = 'vCloudCourseAccess',
  VCLOUD_WORK_SHIFTS = 'vCloudWorkShiftsAccess',
}
